import {Grid, Header, Popup} from "semantic-ui-react";
import NumberFormat from "react-number-format";
import React from "react";

const BenefitItem = ({ label, value, tooltipText, infoIcon }) => (
    <Grid.Column>
        <Header as="h4" className="neutral900Text">
            <NumberFormat value={value} displayType="text" thousandSeparator prefix="$"/>
        </Header>
        <p>
            <span className="primaryBlue">{label}</span>
            <Popup
                position="top left"
                on="hover"
                style={{cursor: 'pointer'}}
                trigger={<span>{infoIcon}</span>}
            >
                <span className="smaller">{tooltipText}</span>
            </Popup>
        </p>
    </Grid.Column>
);

export default BenefitItem;